import { IonSegment, IonSegmentButton } from '@ionic/react';

export interface ISegmentInputProps<T extends string | undefined> {
    value: T;
    onChange: (newValue: T) => void;
    children: React.ReactNode;
}

export const SegmentInput = <T extends string | undefined>({ value, onChange, children }: ISegmentInputProps<T>) => {
    const handleChange = (e: any) => {
        if (onChange) {
            onChange(e.detail.value);
        }
    };

    return (
        <IonSegment mode="ios" style={{marginTop: 15, marginBottom: 10}} value={value ? String(value) : undefined} onIonChange={handleChange}>
            {children}
        </IonSegment>
    );
};

export interface ISegmentButtonProps<T extends string | undefined> {
    value: T;
    children: React.ReactNode;
}

export const SegmentButton = <T extends string | undefined>({ value, children }: ISegmentButtonProps<T>) => {
    return (
        <IonSegmentButton mode="ios" value={value ? String(value) : undefined}>
            <div style={{paddingTop: 5, paddingBottom: 5}}>
                {children}
            </div>
        </IonSegmentButton>
    );
};
